import { render, staticRenderFns } from "./StatisticBars.vue?vue&type=template&id=7728b528&scoped=true"
import script from "./StatisticBars.vue?vue&type=script&lang=js"
export * from "./StatisticBars.vue?vue&type=script&lang=js"
import style0 from "./StatisticBars.vue?vue&type=style&index=0&id=7728b528&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7728b528",
  null
  
)

export default component.exports